import {
    AUTO_STYLE,
    AnimationTriggerMetadata,
    animate,
    animateChild,
    group,
    query,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';

const DEFAULT_DURATION = 200;

/**
 * Derived from https://github.com/filipows/angular-animations/blob/master/lib/other/collapse.animation.ts
 */

export function collapseAnimation(
    options?: IAnimationOptions
): AnimationTriggerMetadata {
    return trigger((options && options.anchor) || 'collapse', [
        state(
            '1',
            style({
                height: '0',
                margin: '0',
                visibility: 'hidden',
                overflow: 'hidden'
            })
        ),
        state(
            '0',
            style({
                height: AUTO_STYLE,
                visibility: AUTO_STYLE,
                margin: AUTO_STYLE,
                overflow: 'hidden'
            })
        ),
        transition(
            '0 => 1',
            [...animateIncludingChildren('ease-in', options)],
            {
                params: {
                    delay: (options && options.delay) || 0,
                    duration: (options && options.duration) || DEFAULT_DURATION
                }
            }
        ),
        transition(
            '1 => 0',
            [...animateIncludingChildren('ease-out', options)],
            {
                params: {
                    delay: (options && options.delay) || 0,
                    duration: (options && options.duration) || DEFAULT_DURATION
                }
            }
        )
    ]);
}

function animateIncludingChildren(
    easing: 'ease-in' | 'ease-out',
    options?: IAnimationOptions
) {
    return [
        ...(options && options.animateChildren === 'before'
            ? [query('@*', animateChild(), { optional: true })]
            : []),
        group([
            group([
                query('@*', animateChild(), { optional: true }),
                animate('{{duration}}' + 'ms ' + '{{delay}}' + 'ms ' + easing)
            ]),
            ...(!options ||
            !options.animateChildren ||
            options.animateChildren === 'together'
                ? [query('@*', animateChild(), { optional: true })]
                : [])
        ]),
        ...(options && options.animateChildren === 'after'
            ? [query('@*', animateChild(), { optional: true })]
            : [])
    ];
}

interface IAnimationOptions {
  /**
   * Name of the animation anchor that will be used in a template
   */
  anchor?: string;
  /**
   * Duration in ms
   */
  duration?: number;
  /**
   * Delay in ms
   *
   * Default: 0
   */
  delay?: number;
  /**
   * This parameter can only be set in a component's decorator.
   * Cannot be set in a template.
   *
   * Whether children animation should run 'before', 'together' or 'after' animation.
   * When set to 'none' chldren are not animated.
   *
   * Default: 'together'
   */
  animateChildren?: 'before' | 'together' | 'after' | 'none';
}